export function initContextMenu(query = document.querySelectorAll('.js-contextMenu')) {
    function adjustPosition(menu) {
        const list = menu.querySelector('.contextMenu__list');
        if (!list) return;

        const rect = list.getBoundingClientRect();

        if (rect.right > window.innerWidth) {
            menu.classList.add('is-flipped-x');
        }

        if (rect.bottom > window.innerHeight) {
            menu.classList.add('is-flipped-y');
        }
    }

    function closeAllMenus() {
        for (const menu of query) {
            menu.querySelector('.js-contextMenuToggle').setAttribute('aria-expanded', 'false');
            menu.classList.remove('is-open', 'is-flipped-x', 'is-flipped-y');
        }
    }

    document.addEventListener('click', function (e) {
        const toggle = e.target.closest('.js-contextMenuToggle');

        if (toggle) {
            e.stopPropagation();
            const menu = toggle.closest('.js-contextMenu');
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

            closeAllMenus();

            if (!isExpanded) {
                toggle.setAttribute('aria-expanded', 'true');
                menu.classList.add('is-open');
                adjustPosition(menu);
            }

            return;
        }

        closeAllMenus();
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeAllMenus();
        }
    });
}